export default __webpack_public_path__ + "static/media/cv.a3542914.png";